/**
 * A CONSULTATIVE TRANSFER IN FLIGHT.
 *
 * Starting one leaves you on TWO calls: the original, parked, and a consult leg
 * you are now speaking on. The controls that finish it — hand over, merge the
 * two, or abandon and go back — live on the consult call's page but act on the
 * ORIGINAL call's id, so the pair has to survive the navigation between them.
 *
 * Kept deliberately in memory and not in storage. A reload during a consult
 * drops the bar rather than resurrecting a transfer the server may already have
 * settled; the original call is still there in the roster, and the server's
 * `pending` row is reconciled by the sweeper when its leg ends. Guessing wrong
 * here would show a Complete button that 409s, which is exactly the kind of
 * lying control this surface is being cleaned of.
 */
import { createStore } from '@/lib/tinyStore';

export interface PendingTransfer {
  readonly transferId: string;
  /** The call being handed over — where `complete` and `cancel` are posted. */
  readonly originalCallId: string;
  /** The second leg, where the transferor is talking to the target. */
  readonly consultCallId: string;
  /** Who is being consulted, for the bar's wording. */
  readonly targetName: string;
}

export const pendingTransferStore = createStore<PendingTransfer | null>(null);

export const pendingTransferActions = {
  start(transfer: PendingTransfer): void {
    pendingTransferStore.set(transfer);
  },
  clear(transferId?: string): void {
    pendingTransferStore.set((current) =>
      current === null || (transferId !== undefined && current.transferId !== transferId)
        ? current
        : null,
    );
  },
};

export const selectPendingTransfer = (state: PendingTransfer | null): PendingTransfer | null =>
  state;
